import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FavoritesProvider } from './context/FavoritesContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

import Home from './pages/Home';
import Categorias from './pages/Categorias';
import CategoriaDetalle from './pages/CategoriaDetalle';
import ProveedorDetalle from './pages/ProveedorDetalle';
import Buscar from './pages/Buscar';
import Favoritos from './pages/Favoritos';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Anunciate from './pages/Anunciate';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Contacto from './pages/Contacto';
import Nosotros from './pages/Nosotros';
import NotFound from './pages/NotFound';

import './App.css';

export default function App() {
  return (
    <FavoritesProvider>
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categorias" element={<Categorias />} />
            <Route path="/categoria/:slug" element={<CategoriaDetalle />} />
            <Route path="/proveedor/:id" element={<ProveedorDetalle />} />
            <Route path="/buscar" element={<Buscar />} />
            <Route path="/favoritos" element={<Favoritos />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/anunciate" element={<Anunciate />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </FavoritesProvider>
  );
}
